// extracted by mini-css-extract-plugin
export default {"gray-60":"rgb(105, 111, 119)","gray-90":"rgb(33, 38, 42)","parentInfoLabel":"styles_parentInfoLabel__ZZvam","parentInfoText":"styles_parentInfoText__oaXMG"};